import axios from 'axios';
import { configRefs } from '@utils/config';

async function getComponentFrameworkDisplayData(node, user) {
  const displayDataResponse = await axios.get(`${await configRefs.apis.componentFramework.get()}/api/References/GetDisplayInfo/${node.referenceId}`);
  let src = `${await configRefs.apis.componentFramework.get()}/Proxy/ComponentViewer` + `?userID=${user?.id ?? "guest"}` + `&componentID=${encodeURIComponent(displayDataResponse.data.ComponentID)}` + `&componentType=${encodeURIComponent(displayDataResponse.data.ComponentType)}` + `&institutionID=${encodeURIComponent(user?.institution?.id ?? "")}`;
  if (node.pm2.learningObjectId && node.pm2.learningObjectTitle) {
    src += `&learningObjectId=${encodeURIComponent(node.pm2.learningObjectId)}` + `&learningObjectTitle=${encodeURIComponent(node.pm2.learningObjectTitle)}`;
  }
  const displayData = {
    minSize: {
      height: Math.min(displayDataResponse.data.Dimensions.MinHeight, displayDataResponse.data.Dimensions.MaxHeight ?? Infinity, displayDataResponse.data.Dimensions.MaxWidth ? displayDataResponse.data.Dimensions.MaxWidth / displayDataResponse.data.Dimensions.DefaultWidth * displayDataResponse.data.Dimensions.DefaultHeight : Infinity),
      width: Math.min(displayDataResponse.data.Dimensions.MinWidth, displayDataResponse.data.Dimensions.MaxWidth ?? Infinity, displayDataResponse.data.Dimensions.MaxHeight ? displayDataResponse.data.Dimensions.MaxHeight / displayDataResponse.data.Dimensions.DefaultHeight * displayDataResponse.data.Dimensions.DefaultWidth : Infinity)
    },
    maxSize: {
      height: displayDataResponse.data.Dimensions.MaxHeight,
      width: displayDataResponse.data.Dimensions.MaxWidth
    },
    proportions: {
      height: displayDataResponse.data.Dimensions.DefaultHeight,
      width: displayDataResponse.data.Dimensions.DefaultWidth
    },
    fixedHeight: false,
    src
  };

  // except for HTML components, we force all other component embeds to
  // become 750px tall
  if (displayDataResponse.data.ComponentType !== "html" && node.options.autoActivate && window.innerWidth > 768) {
    // anything but html components are forced to fit a specific height
    displayData.minSize.height = 750;
    displayData.maxSize.height = 750;
    displayData.proportions.height = 750;
    displayData.fixedHeight = true;
  }
  return displayData;
}

export { getComponentFrameworkDisplayData };
//# sourceMappingURL=component-framework.get-display-data.js.map
